import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initLanguageCallback } from "./uitls";

// import { initLanguageCallback } from './utils';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(
    {
      fallbackLng: "en",
      debug: true,
      detection: {
        order: ["navigator"],
        caches: ["localStorage"],
      },
      resources: {
        en: {},
        ja: {},
        ko: {},
        th: {},
        "zh-TW": {},
        "zh-HK": {},
      },
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    },
    initLanguageCallback
  );

export default i18n;
